import React from 'react';
import { tFor } from '../../i18n/i18n.js';

const STEP_KEYS = ['steps.service', 'steps.time', 'steps.details', 'steps.pay'];

export function Stepper({ step, locale }) {
  const t = tFor(locale);
  return (
    <div className="sp-stepper" role="progressbar" aria-valuemin={1} aria-valuemax={STEP_KEYS.length} aria-valuenow={step}>
      {STEP_KEYS.map((key, idx) => {
        const n = idx + 1;
        const cls = [
          'sp-stepper__step',
          step === n && 'is-current',
          step > n && 'is-done',
        ].filter(Boolean).join(' ');
        return (
          <div key={key} className={cls}>
            <div className="sp-stepper__bar">
              <div
                className="sp-stepper__bar-fill"
                style={{ width: step >= n ? '100%' : '0%' }}
              />
            </div>
            <span className="sp-stepper__label">
              {n}. {t(key)}
            </span>
          </div>
        );
      })}
    </div>
  );
}
